export default function loadScriptPromise(url, scriptCharset = "utf-8") {
  return new Promise((resolve, reject) => {
    let script = document.createElement("script")
    script.type = "text/javascript"
    script.onerror = reject
    script.onload = resolve
    script.src = url
    script.charset = scriptCharset
    document.body.appendChild(script)
  })
}
